import React from 'react';
import PropTypes from 'prop-types';

import { RadioWrapper, RadioInput } from './Radio.styled';

import { LabelStyled, LabelSecondaryStyled } from '../shared';

export const radioSize = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  DEFAULT: 'default',
  MEDIUM: 'medium',
};

export const radioLabelsAlignment = {
  START: 'start',
  END: 'end',
  JUSTIFY: 'justify',
};

export default function Radio(props) {
  const { id, checked, disabled, size, labelStyle, labelSecondary } = props;

  return (
    <RadioWrapper size={size} className={props.className} disabled={disabled}>
      <RadioInput
        type='radio'
        id={id}
        name={props.groupName}
        value={props.value}
        checked={checked}
        disabled={disabled}
        onChange={props.onChange}
      />
      <LabelStyled
        htmlFor={id}
        labelsAlignment={props.labelsAlignment}
        checked={checked}
        style={labelStyle}
      >
        {props.label}
        {labelSecondary && (
          <LabelSecondaryStyled>{labelSecondary}</LabelSecondaryStyled>
        )}
      </LabelStyled>
    </RadioWrapper>
  );
}

Radio.defaultProps = {
  size: radioSize.DEFAULT,
  labelsAlignment: radioLabelsAlignment.START,
  checked: false,
  disabled: false,
  onChange: () => {},
};

Radio.propTypes = {
  className: PropTypes.string,
  /**
   * The id assigned to input field
   */
  id: PropTypes.string,
  /**
   * Name of the radiogroup
   */
  groupName: PropTypes.string,
  /**
   * Text to show for the radio select
   */
  label: PropTypes.string,
  /**
   * Secondary text to show content
   */
  labelSecondary: PropTypes.string,
  /**
   * This prop will change the arrangement of the label and secondaryLabel if exists
   */
  labelsAlignment: PropTypes.oneOf(Object.values(radioLabelsAlignment)),
  /**
   * The value attribute is a DOMString used to identify which radio button in a group is selected.
   */
  value: PropTypes.string,
  /**
   * Function handler for change event
   */
  onChange: PropTypes.func,
  /**
   * This prop allows to change the size of the component based on our <a href="https://storybook.wikifactory.com/?path=/docs/3--page">typography scale system</a>
   */
  size: PropTypes.oneOf(Object.values(radioSize)),
  /**
   * If true, will show the radio button disabled
   */
  disabled: PropTypes.bool,
  /**
   * If true, will show the radio button as checked
   */
  checked: PropTypes.bool,
};
